module.exports = __webpack_public_path__ + "img/banner.d8581580.png";